import { addLocale, useLocale } from 'ttag';

(async () => {
  const languageCode = window?.config?.language_code;
  const isoLanguageCode = window?.config?.iso_language_code;

  if (!languageCode || languageCode !== 'en') {
    let language = languageCode;
    if (isoLanguageCode === 'de-AT') {
      language = isoLanguageCode;
    }
    const ttagTranslation = await import(`../locale/${language}.po.json`);

    addLocale(languageCode, ttagTranslation);
    useLocale(languageCode);
  }
})();

async function loadTranslations() {
  const languageCode = window?.config?.language_code || 'da';
  const isoLanguageCode = window?.config?.iso_language_code;

  if (!languageCode || languageCode !== 'en') {
    let language = languageCode;
    if (isoLanguageCode === 'de-AT') {
      language = isoLanguageCode;
    }
    const ttagTranslation = await import(`../locale/${language}.po.json`);

    addLocale(languageCode, ttagTranslation);
    useLocale(languageCode);
  }
}

export default loadTranslations;
